videoPlayerControls.directive('videoPlayerControls', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'video_player_controls/templates/' + helperService.getRedesignPathPrefix() + 'videoPlayerControls.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
